import { createFileRoute } from '@tanstack/react-router'
import { PartnerDetailPage } from '~/features/admin/partner-detail-page'

export const Route = createFileRoute('/admin/partners/$partnerId')({
  component: PartnerDetailRoute,
})

function PartnerDetailRoute() {
  const { partnerId } = Route.useParams()
  return <PartnerDetailPage partnerId={partnerId} />
}
